/*
 *
 * DesktopNavBar
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 17-Oct-2024
 */

import { connect } from 'react-redux'
import { userPermissions, userProfileType } from 'Store/selectors'
import { doSetPblSourcePage } from 'Store/actions/pblManagement'
import { doSetBookingSourcePage } from 'Route/BookingManagement/modules/BookingManagementActions'
import DesktopNavBar from './DesktopNavBar'

const mapDispatchToProps = {
  doSetBookingSourcePage,
  doSetPblSourcePage
}

const mapStateToProps = (state) => ({
  userPermissions: userPermissions(state),
  type: userProfileType(state),
  userProfile: state?.user?.userProfile || [],
  getSubscriptionArray: state?.user?.getSubscriptionArray || []
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(DesktopNavBar)
